import { Fade } from "./Reveal";
import { ContactForm } from "./ContactForm";

export const Final = () => {
  const scrollToContact = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section data-testid="final-section" className="bg-[#F2F3F5] text-[#0D1B2A]">
      <div className="relative px-6 md:px-10 pt-24 md:pt-36 pb-24 md:pb-40">
        <div className="grid grid-cols-12 gap-x-6">
          <Fade className="col-span-12 md:col-span-6 md:col-start-6" delay={0.1}>
            <button onClick={scrollToContact} className="btn-sharp text-[#0D1B2A]" style={{ "--btn-hover-text": "#F2F3F5" }} data-testid="final-cta-button">
              <span>Contact</span>
              <span aria-hidden>↓</span>
            </button>
          </Fade>
        </div>
      </div>

      <ContactForm />
    </section>
  );
};
